import { ANALYTICS_SCREEN_APP_LISTING, ANALYTICS_SCREEN_MANAGE_APP_REQUESTS } from '../../analytics/Sources';
export const MARKETPLACE_APP_KEY = 'MARKETPLACE_APP_KEY';
export const INSTALLABLE_APP_IDENTIFIER = 'INSTALLABLE_APP_IDENTIFIER';
export const makeMarketplaceAppKeyIdentifier = appKey => ({
  type: MARKETPLACE_APP_KEY,
  keyForInstall: appKey
});
export const makeInstallableAppKeyIdentifier = installableId => ({
  type: INSTALLABLE_APP_IDENTIFIER,
  keyForInstall: installableId
});
/**
 * Known values of the "location" where the app install flow is being triggered from.
 * This is primarily used for attributing app installs to a specific user flow within the product(s).
 */
export const AppInstallLocation = Object.freeze({
  EmbeddedMarketplaceAppListing: ANALYTICS_SCREEN_APP_LISTING.name,
  EmbeddedMarketplaceManageAppRequests: ANALYTICS_SCREEN_MANAGE_APP_REQUESTS.name
});